import enLocale from './en'

export default {
  ...enLocale,

  language: 'ภาษา',
  confirm: 'ยืนยัน',
  go: 'ไป',
  status: 'สถานะ',
  balance: 'ยอดคงเหลือ',
  cash: 'เงินสด',
  createNew: 'สร้างใหม่',
  home: 'หน้าแรก',
  market: 'ตลาด',
  markets: 'ตลาด',
  portfolio: 'พอร์ตโฟลิโอ',
  license: 'ใบอนุญาต',
  withdraw: 'ถอน',
  auditChecking: 'กำลังตรวจสอบ',
  insufficientFunds: 'เงินไม่เพียงพอ',
  buy: 'ซื้อ',
  history: 'ประวัติ',
  seeMore: 'ดูเพิ่มเติม',
  theme: 'ธีม',
  network: 'เครือข่าย',
  walletBalance: 'ยอดเงินในวอลเล็ต',
  collect: 'รับ',
  approve: 'อนุมัติ',
  ticket: 'ใบอนุญาต',
  category: 'หมวดหมู่',
  sortBy: 'จัดเรียงตาม',
  issue: 'ออกสินค้า',
  detail: 'รายละเอียด',
  stakingType: 'หลักประกัน',
  stakingTypeInfo: 'เพื่อป้องกันการยืนยันผลโดยมิชอบ โปรด stake โทเคนหรือ NFT ปัจจุบัน',
  subscriptionAmount: 'จำนวนการซื้อ',
  subscription: 'การสมัคร',
  subscribe: 'ซื้อ',
  max: 'สูงสุด',
  marketClosed: 'ตลาดปิด',
  deposit: 'เพิ่ม',
  verifiedNFT: 'ตรวจสอบใบอนุญาต',
  select: 'เลือก',
  selected: 'เลือกแล้ว',
  moreNFT: 'รับใบอนุญาตเพิ่มเติม',
  forecastEvent: 'เหตุการณ์',
  subscribeEndDate: 'เวลาซื้อขายสุดท้าย',
  specifyExpiryDate: 'กำหนดเวลาหมดอายุ',
  endDate: 'เวลาสิ้นสุด',
  validityPeriod: 'เวลาหมดอายุ',
  marketEndDate: 'เวลาหมดอายุ',
  liquidityMin: 'สภาพคล่องขั้นต่ำ',
  premiumMin: 'ค่าพรีเมียมขั้นต่ำ',
  paymentCurrency: 'สกุลเงินที่ใช้ชำระ',
  defaultOdds: 'เลเวอเรจเริ่มต้น',
  setDefaultOdds: 'ตั้งค่าเลเวอเรจ',
  minInvestAmout: 'กำหนดเงินลงทุนขั้นต่ำ',
  depositMargin: 'เพิ่มสภาพคล่อง',
  totalPayment: 'ยอดชำระรวม',
  rewards: 'รางวัล',
  rewardRate: 'อัตรารางวัล',
  release: 'ปล่อย',
  fee: 'ค่าธรรมเนียม',
  marginFeeRate: 'อัตราค่าธรรมเนียม',
  cdsInfoOne: 'ออกสินค้า ต้อง stake มาร์จิน ตั้งเลเวอเรจเริ่มต้นและเงินลงทุนขั้นต่ำ',
  cdsInfoTwo: 'มาร์จินที่ไม่ได้ใช้สามารถถอนได้ทุกเมื่อ',
  cdsInfoThree: 'หากมีการอุทธรณ์มากกว่า 1 ราย จะเริ่มกลไกการกำกับดูแลชุมชน',
  deposited: 'ลงทุนแล้ว',
  issued: 'ออกแล้ว',
  depositedCDS: 'สินค้าที่ลงทุน',
  totalProfit: 'กำไรรวม',
  allOrDeposited: 'รวม/ลงทุน',
  rewardsOrProfit: 'รางวัล/กำไร',
  estimatedInvested: 'ประมาณ/ลงทุน',
  profit: 'กำไร',
  yesterdayProfit: 'กำไรเมื่อวาน',
  eventConfirming: 'กำลังยืนยันเหตุการณ์',
  appeal: 'อุทธรณ์',
  appealing: 'กำลังอุทธรณ์',
  appealFailed: 'อุทธรณ์ไม่สำเร็จ',
  occured: 'เกิดขึ้น',
  notOccured: 'ไม่เกิดขึ้น',
  governanceMechanism: 'เมื่อจำนวนการอุทธรณ์มากกว่า 1 จะเริ่มกลไกกำกับดูแล',
  appealLimit: 'จำนวนการอุทธรณ์ไม่เกิน 1 คน',
  waitResult: 'รอผลการอุทธรณ์',
  frozenMargin: 'มาร์จินที่ถูกแช่แข็ง',
  marginBalance: 'ยอดมาร์จิน',
  cancel: 'ยกเลิก',
  defaultAhead: 'เกิดก่อนกำหนด',
  occur: 'เกิดขึ้น',
  notOccur: 'ไม่เกิดขึ้น',
  stakingToChallenge: 'Stake เพื่อท้าทาย',
  challenged: 'ท้าทายแล้ว',
  checking: 'กำลังตรวจสอบ',
  fail: 'ล้มเหลว',
  endTime: 'นับถอยหลังถึงสิ้นสุด',
  guaranteeing: 'กำลังดำเนินการ',
  guaranteeingEvent: 'การทำนายกำลังดำเนินการ',
  confirmsEventAdvance: 'ยืนยันการเกิดก่อนกำหนด',
  waitConfirmation: 'รอยืนยัน',
  triggerEvent: 'ยืนยันว่าเกิดขึ้น',
  notTriggerEvent: 'ยืนยันว่าไม่เกิดขึ้น',

  appealInfoOne: 'หากเห็นว่าผลการตัดสินคลาดเคลื่อน สามารถ “ท้าทาย” และให้ชุมชนตัดสินผลสุดท้ายได้',
  check: 'ตรวจสอบ',
  contentIllegal: 'เหตุการณ์ที่ทำนายมีเนื้อหาที่ไม่เหมาะสม โปรดแก้ไขใหม่',
  subscribed: 'สินค้าที่ลงทุน',
  receivingCompensation: 'รอดำเนินการ',
  received: 'ผลตอบแทนรวม',
  receive: 'รับ',
  compensationAmount: 'จำนวนชดเชยเมื่อเกิดขึ้น',
  liquidity: 'สภาพคล่อง',
  injectLiquidity: 'เพิ่มสภาพคล่อง',
  uRLContent: 'URL/เนื้อหา',
  resolutionSource: 'แหล่งอ้างอิง',
  textareaInfo: 'โปรดอธิบายเหตุการณ์นี้โดุยย่อ',

  issuerResult: 'ผลของผู้ออก',
  daoResult: 'ผลของ DAO',
  waitingGovernanceResult: 'กำลังรอผลการกำกับดูแล',
  eventFinished: 'เหตุการณ์สิ้นสุดแล้ว',
  recycleTicket: 'เรียกคืนใบอนุญาต',
  eventCancelled: 'เหตุการณ์ถูกยกเลิก',
  challenge: 'ท้าทาย',
  share: 'แชร์',
  USDT: 'USDT',
  donations: 'บริจาค',

  issueMsgPleaseSelectLicense: 'โปรดเลือกใบอนุญาต',
  issueMsgLicenseCannotBeStaked: 'ใบอนุญาตไม่สามารถ stake ได้',
  issueMsgNetworkNotConnected: 'เครือข่ายยังไม่เชื่อมต่อ',
  issueMsgEventEmpty: 'ยังไม่ได้กรอกเหตุการณ์',
  issueMsgSelectLicense: 'โปรดเลือกใบอนุญาต',
  issueMsgLastTradingDateEmpty: 'ยังไม่ได้กรอกเวลาซื้อขายสุดท้าย',
  issueMsgExpirationDateEmpty: 'ยังไม่ได้กรอกเวลาหมดอายุ',
  issueMsgLastTradingDateGreaterThanToday: 'เวลาซื้อขายสุดท้ายต้องมากกว่าวันนี้',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'เวลาซื้อขายสุดท้ายมากกว่าเวลาหมดอายุ',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'เวลาสิ้นสุด {eventEndDate} มากกว่าวันสิ้นสุดการเช่า {rentalEndDate}',
  issueMsgInsufficientBalance: 'ยอดเงินไม่เพียงพอ',
  issueMsgTransactionFailed: 'ธุรกรรมล้มเหลว',
  issueMsgIssueSuccess: 'ออกสินค้าสำเร็จ',
  issueMsgTransactionCancelled: 'ธุรกรรมถูกยกเลิก',

  short: {
    ...enLocale.short,
    confirmsEventAdvance: 'เกิดก่อนกำหนด',
    waitConfirmation: 'รอยืนยัน',
    defaultChallenging: 'เกิดขึ้น-กำลังท้าทาย',
    notDefaultChallenging: 'ไม่เกิดขึ้น-กำลังท้าทาย',
    defaultChallengeFailed: 'เกิดขึ้น-ท้าทายล้มเหลว',
    notDefaultChallengeFailed: 'ไม่เกิดขึ้น-ท้าทายล้มเหลว',
    defaultWaitingResult: 'เกิดขึ้น-รอผลกำกับดูแล',
    notDefaultWaitingResult: 'ไม่เกิดขึ้น-รอผลกำกับดูแล',
    defaultGovernanceMechanism: 'เกิดขึ้น-ยืนยันโดยกำกับดูแล',
    notDefaultGovernanceMechanism: 'ไม่เกิดขึ้น-ยืนยันโดยกำกับดูแล',
  },

  wallet: {
    ...enLocale.wallet,
    openWallet: 'เปิดวอลเล็ต',
    connectWallet: 'เชื่อมต่อวอลเล็ต',
    connectingWallet: 'กำลังเชื่อมต่อวอลเล็ต',
    connectYourWallet: 'เชื่อมต่อวอลเล็ตของคุณ',
    disconnect: 'ตัดการเชื่อมต่อ',
    wrongNetwork: 'เครือข่ายไม่ถูกต้อง',
  },

  NFT: {
    ...enLocale.NFT,
    getPrediLicense: 'รับใบอนุญาต Predi',
    referralRewards: 'รางวัลการแนะนำ',
    mintYourLicence: 'มิ้นต์ใบอนุญาตของคุณ',
    usageRights: 'สิทธิ์การใช้งาน',
    issuePredictionProducts: 'ออกสินค้าทำนาย',
    governance: 'กำกับดูแล',
    properties: 'คุณสมบัติ',
    tradable: 'ซื้อขายได้',
    rentable: 'ให้เช่าได้',
    usable: 'ใช้งานได้',
    marketsToIssue: 'ตลาดที่ออกได้',
    times: 'ครั้ง',
    availableTimes: 'จำนวนครั้งที่ใช้ได้',
    ticketId: 'รหัสตั๋ว',
    cancelRentHint: 'ใบอนุญาตนี้กำลังเช่า โปรดยกเลิกก่อนจึงขายได้',
    seeMore: 'ดูเพิ่มเติม',
    sell: 'ขาย',
    rent: 'ให้เช่า',
    share: 'แชร์',
    common: 'ทั่วไป',
    scarcity: 'หายาก',
    attributive: 'เชิงคุณลักษณ์',
    numbers: 'หมายเลขออก',
    issueTip: 'ออกตลาดทำนาย 10 รายการต่อใบอนุญาต',
    price: 'ราคา',
    success: 'สำเร็จ',
    getNFT: 'รับใบอนุญาตเรียบร้อย',
    issueCDS: 'ออกตลาด Predi',
    buyNow: 'ซื้อเลย',
    mintNow: 'มิ้นต์เลย',
    rule: 'กฎ',
    comingSoon: 'เร็ว ๆ นี้!',
    type: 'ประเภท',
    from: 'จาก',
    to: 'ถึง',
    me: 'ฉัน',
    rented: 'เช่าแล้ว',
    sold: 'ขายแล้ว',
    tabGetLicense: 'รับใบอนุญาต',
    tabMyLicense: 'ใบอนุญาตของฉัน',
    bought: 'ซื้อแล้ว',
    boughtProducts: 'สินค้าที่ซื้อ',
    investedProducts: 'สินค้าที่ลงทุน',
    issuedProducts: 'สินค้าที่ออก',
    positions: 'โพสิชั่น',
    options: 'ตัวเลือก',
    all: 'ทั้งหมด',
    volume: 'ปริมาณ',
    newest: 'ล่าสุด',
    pending: 'รอดำเนินการ',
    audit: 'ตรวจสอบ',
    loading: 'กำลังโหลด',
    empowering: 'เสริมพลังให้ผู้มองการณ์ไกลทำนายอนาคต',
    myPositions: 'โพสิชั่นของฉัน',
    challengeCredit: 'เครดิตการท้าทาย',
    challengeStatus: 'สถานะการท้าทาย',
    succeed: 'สำเร็จ',
    wait: 'รอ',
    return: 'กลับ',
    createYourOwnMarket: 'สร้างตลาดของคุณเอง',
    waitChallenge: 'เหตุการณ์กำลังรอการท้าทาย',
    waitingGovernanceResult: 'กำลังรอผลกำกับดูแล',
    eventFinished: 'เหตุการณ์สิ้นสุดแล้ว',
    cancelled: 'ถูกยกเลิก',
    predictionProduct: 'สินค้าทำนาย',
    complaintCountdown: 'นับถอยหลังการร้องเรียน',
    setResult: 'ตั้งค่าผลลัพธ์',
    recycleTicket: 'เรียกคืนใบอนุญาต',
    eventCancelled: 'เหตุการณ์ถูกยกเลิก',
    auditChecking: 'กำลังตรวจสอบ',
    insufficientFunds: 'เงินไม่เพียงพอ',
    buyTicket: 'ซื้อตั๋ว',
    listYourToken: 'ลิสต์โทเค็นของคุณ',
  },

  claim: {
    ...enLocale.claim,
    title: 'รับ PRDs ฟรี',
    subtitle: 'รับโทเค็น PRDs ด้วยคลิกเดียว',
    walletAddress: 'ที่อยู่วอลเล็ต',
    status: 'สถานะ',
    connectWalletFirst: 'โปรดเชื่อมต่อวอลเล็ตก่อน',
    eligibility: {
      claimed: 'คุณรับแล้ว',
      eligible: 'คุณมีสิทธิ์รับ',
      error: 'ตรวจสอบสิทธิ์ผิดพลาด',
    },
    button: {
      claim: 'รับ',
      alreadyClaimed: 'รับแล้ว',
      connect: 'เชื่อมต่อ',
    },
    footerNotice: 'แต่ละวอลเล็ตรับได้เพียงครั้งเดียว ตรวจสอบว่าเชื่อมต่อเครือข่ายถูกต้อง',
    messages: {
      connectFirst: 'โปรดเชื่อมต่อวอลเล็ตก่อน',
      claimSuccess: 'รับสำเร็จ!',
      claimFailed: 'รับไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
      txCancelled: 'การทำธุรกรรมถูกยกเลิก',
      onlyOnce: 'ผู้ใช้แต่ละรายรับได้ครั้งเดียว',
      insufficientBalance: 'ยอดในสัญญาไม่พอ โปรดลองภายหลัง',
    },
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'กรุณาใส่เนื้อหาที่ต้องการค้นหา',
  predictionProduct: 'สินค้าทำนาย',
  listYourToken: 'ลิสต์โทเค็นของคุณ',
  description: 'รายละเอียด',
  positions: 'โพสิชั่น',
  options: 'ตัวเลือก',
  all: 'ทั้งหมด',
  volume: 'ปริมาณ',
  newest: 'ล่าสุด',
  pending: 'รอดำเนินการ',
  audit: 'ตรวจสอบ',
  loading: 'กำลังโหลด',
  challengeCredit: 'เครดิตการท้าทาย',
  challengeStatus: 'สถานะการท้าทาย',
  succeed: 'สำเร็จ',
  wait: 'รอ',
  return: 'กลับ',
  waitChallenge: 'เหตุการณ์กำลังรอการท้าทาย',
  complaintCountdown: 'นับถอยหลังการร้องเรียน',
  setResult: 'ตั้งค่าผลลัพธ์',
  issueParticipateUntil: 'ผู้ใช้สามารถมีส่วนร่วมในผลิตภัณฑ์นี้ได้จนถึง',
  specifyLastTradingDate: 'ระบุเวลาซื้อขายครั้งสุดท้าย',
  empowering: 'เสริมพลังให้ผู้มองการณ์ไกลทำนายอนาคต',
  amount: 'จำนวน',
  createYourOwnMarket: 'สร้างตลาดของคุณเอง',
  
  licenses: 'ใบอนุญาต',
  prediLicense: 'ใบอนุญาต Predi',
  issuableQuantity: 'จำนวนที่สามารถออกได้',
  disabled: 'ปิดใช้งาน',
  battleImage: 'รูปภาพการพิสูจน์',
  upload: 'อัปโหลด',
  showSample: 'ดูตัวอย่าง',
  battleInformation: 'ข้อมูลการพิสูจน์',
  baseToken: 'โทเค็นพื้นฐาน',
  collateral: 'หลักประกัน',
  currentLicense: 'ใบอนุญาตปัจจุบัน',
  predictionProject: 'โปรเจกต์ทำนาย:',
  issueExpireIntro: 'เมื่อถึงเวลาหมดอายุ ผู้ที่เลือกตัวเลือกที่ถูกต้องจะแบ่งปันโทเค็นจากพูลผลิตภัณฑ์ตามส่วนแบ่งการมีส่วนร่วมของพวกเขา',
  issueConfirmAdvance: 'ผลลัพธ์สามารถได้รับการยืนยันล่วงหน้าโดยผู้ออก หากเหตุการณ์เกิดขึ้นก่อนเวลาหมดอายุ',
  issueChallengeWithin7Days: 'หากผู้เข้าร่วมไม่เห็นด้วยกับผลลัพธ์ของเหตุการณ์ที่ผู้ออกยืนยัน พวกเขาสามารถ "ท้าทาย" ได้ภายใน 7 วันนับจากวันยืนยัน',
  issueAttention: 'คำเตือน: Predi มุ่งมั่นในการส่งเสริมประสบการณ์ด้านความบันเทิงและสังคม กิจกรรมที่เกี่ยวข้องกับการพนันทุกรูปแบบถูกห้ามอย่างเคร่งครัดบนแพลตฟอร์มนี้',
  eventSampleTitle: 'เหตุการณ์',
  issueSampleCrypto: '[สกุลเงิน] ช่วงราคาของ Bitcoin ในสิ้นปี 2025 จะเป็นอย่างไร?',
  issueSampleFinance: '[การเงิน] การตัดสินใจเรื่องอัตราดอกเบี้ยของ Federal Reserve สหรัฐอเมริกาใน Q3 2025 จะเป็นอย่างไร?',
  issueSampleTechnology: '[เทคโนโลยี] บริษัทใดจะเปิดตัวผู้ช่วยหุ่นยนต์ AI อัตโนมัติเต็มรูปแบบตัวแรก?',
  issueSampleSports: '[กีฬา] ทีมใดจะคว้าแชมป์ FIFA World Cup 2026?',
  issueSampleSociety: '[สังคม] แพลตฟอร์มโซเชียลมีเดียใดจะมีผู้ใช้รายเดือนเฉลี่ยมากที่สุดในปี 2025?',
  issueSampleOthers: '[อื่นๆ] สงครามรัสเซีย-ยูเครนจะจบลงเมื่อไหร่?',
  issuerResult: 'ผลของผู้ออก',
  daoResult: 'ผลของ DAO',
  predictionToken: 'โทเค็นทำนาย',
  issuer: 'ผู้ออก',
  issuerProfit: 'กำไรของผู้ออก'
}